/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconUmbrella2 = createReactComponent("outline", "umbrella-2", "IconUmbrella2", [["path", { "d": "M5.343 7.343a8 8 0 1 1 11.314 11.314z", "key": "svg-0" }], ["path", { "d": "M10.828 13.34l-4.242 4.243a2 2 0 1 0 2.828 2.828", "key": "svg-1" }]]);

export { IconUmbrella2 as default };
//# sourceMappingURL=IconUmbrella2.mjs.map
